module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-1.e5492f0b.webp";